import { render, staticRenderFns } from "./AllNipInwards.vue?vue&type=template&id=0a051b13&scoped=true&"
import script from "./AllNipInwards.vue?vue&type=script&lang=js&"
export * from "./AllNipInwards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a051b13",
  null
  
)

export default component.exports